import type { Template } from '@/api/v4/template.api';
import { styled } from 'goober';
import { useTemplateScanningStatus } from './use-template-scanning-status.query';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { TemplatesActionsMenu } from './templates-action-menu';
import { formatDate } from '@/helpers/format-date';
import { Loader } from '@/components/loader/loader';

export const TemplateUploadDate = ({ template }: { template: Template }) => {
  useTemplateScanningStatus(template);

  return (
    <UploadDateContainer name="upload-date-container" gap="24px">
      {template.link ? (
        formatDate(template.createdDate)
      ) : (
        <Loader size="small" />
      )}
      <TemplatesActionsMenu template={template} />
    </UploadDateContainer>
  );
};

const UploadDateContainer = styled(Flexbox)`
  ${({ theme }) => theme.typography.acrossPlatform.userName}
`;
